import { render, staticRenderFns } from "./TSelectableGroup.vue?vue&type=template&id=09b63e50"
import script from "./TSelectableGroup.vue?vue&type=script&lang=js"
export * from "./TSelectableGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports